import AdverseEvents from "../pages/AdverseEvents";
import ChangeManagement from "../pages/ChangeManagement";
import ClinicalEval from "../pages/ClinicalEval";
import DeepLiteratureAnalysis from "../pages/DeepLiteratureAnalysis";
import PredicateFinder from "../pages/PredicateFinder.jsx";
import ReguBot from "../pages/ReguBot";
import Reviewer from "../pages/Reviewer.jsx";
import RiskManager from "../pages/RiskManager.jsx";
import Footer from "./Footer";
import Header from "./Header";

const Content = ({ selectedTab }) => {
  return (
    <main className="flex h-full grow-1 flex-col bg-gray-50 p-2 shadow-lg">
      <Header />
      {/* Content Pages */}
      {selectedTab === "ReguBot" && <ReguBot />}
      {selectedTab === "PredicateFinder" && <PredicateFinder />}
      {selectedTab === "AdverseEvents" && <AdverseEvents />}
      {selectedTab === "DocReviewer" && <Reviewer />}
      {selectedTab === "RiskManager" && <RiskManager />}
      {selectedTab === "ChangeManagement" && <ChangeManagement />}
      {selectedTab === "ClinicalEval" && <ClinicalEval />}
      {selectedTab === "DeepLiteratureAnalysis" && <DeepLiteratureAnalysis />}
      <Footer />
    </main>
  );
};

export default Content;
